import { render, staticRenderFns } from "./LicitacaoFornecedorInconsistenciasFornecedor.vue?vue&type=template&id=7c18587f"
import script from "./LicitacaoFornecedorInconsistenciasFornecedor.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorInconsistenciasFornecedor.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorInconsistenciasFornecedor.vue?vue&type=style&index=0&id=7c18587f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports